import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=e0c5bcf4"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VTooltip})
